module.exports = __webpack_public_path__ + "static/media/peter-qa.cfe62b18.png";